module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Misc Sales Execution Form")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' &&
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.miscJobDetails.allModuleId != ''
  ) ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.showModalLoc
    }
  }, [_vm._v("Change Location")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(_vm.miscJobDetails.allModuleId != '') ? _c('h5', {
    staticClass: "mt-2 error"
  }, [_vm._v("\n              JOB TYPE : " + _vm._s(_vm.ShowJOB + " (" + _vm.mainSalesSeries + ")") + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Other Service Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.OtherServicTypeList,
      "id": "OtherServicType",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Service Type"
    },
    model: {
      value: (_vm.miscJobDetails.OtherServicType),
      callback: function($$v) {
        _vm.$set(_vm.miscJobDetails, "OtherServicType", $$v)
      },
      expression: "miscJobDetails.OtherServicType"
    }
  }), _vm._v(" "), (!_vm.miscJobDetails.OtherServicType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormiscJobDetails.OtherServicType))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Misc Job Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.requestTypeList,
      "id": "clientNamenew",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Request Type"
    },
    model: {
      value: (_vm.miscJobDetails.jobType),
      callback: function($$v) {
        _vm.$set(_vm.miscJobDetails, "jobType", $$v)
      },
      expression: "miscJobDetails.jobType"
    }
  }), _vm._v(" "), (!_vm.miscJobDetails.jobType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormiscJobDetails.jobType))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientTypeList,
      "id": "clientNamenew",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Client Type",
      "isDisabled": true
    },
    model: {
      value: (_vm.miscJobDetails.clientType),
      callback: function($$v) {
        _vm.$set(_vm.miscJobDetails, "clientType", $$v)
      },
      expression: "miscJobDetails.clientType"
    }
  }), _vm._v(" "), (!_vm.miscJobDetails.clientType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormiscJobDetails.clientType))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Shipping Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Shipment Type"
    },
    model: {
      value: (_vm.miscJobDetails.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.miscJobDetails, "shipmentType", $$v)
      },
      expression: "miscJobDetails.shipmentType"
    }
  }), _vm._v(" "), (!_vm.miscJobDetails.shipmentType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormiscJobDetails.shipmentType))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Export / Import")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.miscJobDetails.transportType),
      callback: function($$v) {
        _vm.$set(_vm.miscJobDetails, "transportType", $$v)
      },
      expression: "miscJobDetails.transportType"
    }
  }), _vm._v(" "), (!_vm.miscJobDetails.transportType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormiscJobDetails.transportType))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.miscJobDetails.clientType != '2') ? _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Client Name"
    },
    model: {
      value: (_vm.miscJobDetails.clientId),
      callback: function($$v) {
        _vm.$set(_vm.miscJobDetails, "clientId", $$v)
      },
      expression: "miscJobDetails.clientId"
    }
  }), _vm._v(" "), (!_vm.miscJobDetails.clientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errormiscJobDetails.clientId))]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3 justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.miscJobDetails.allModuleId != '',
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addMiscJob
    }
  }, [_vm._v("Save & Send To Execution")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), (_vm.miscJobDetails.allModuleId != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "gutr mt-2 smbutnWidth",
    attrs: {
      "disabled": _vm.miscJobDetails.asignDeleted == '1',
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.proceedToNext('invoice')
      }
    }
  }, [_vm._v("Proceed To Invoice\n            ")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.miscJobDetails.allModuleId != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "disabled": _vm.miscJobDetails.asignDeleted == '1',
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.proceedToNext('sline')
      }
    }
  }, [_vm._v("Save & Proceed To S-Line Payment")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVGM"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "location-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "id": "modal-multi-2",
      "size": "lg",
      "title": 'Change Location Of : ' + _vm.seriesNumber
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.options1,
      "option-value": "pickupLocation",
      "option-text": "pickupLocation",
      "placeholder": "select item"
    },
    model: {
      value: (_vm.objectItem),
      callback: function($$v) {
        _vm.objectItem = $$v
      },
      expression: "objectItem"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12  text-center"
  }, [_c('b-button', {
    staticClass: "mt-4 ml-auto",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    },
    on: {
      "click": _vm.changeLocation
    }
  }, [_c('b', [_vm._v("Save")])]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideModalLoc
    }
  }, [_c('b', [_vm._v("Close")])])], 1)])]), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddFF
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addClient",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.updateClientNew
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "sendExecution",
    attrs: {
      "md-title": _vm.alert.title,
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendExecutionTeam
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47fcf590","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/miscSalesExecution.vue
// module id = 2585
// module chunks = 0